export default __webpack_public_path__ + "static/media/flshs.9c72fb43.png";